export default __webpack_public_path__ + "static/sarah-bracke-6c26c405835df024c97541e2d684a9a8.png";